import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: 'Rubik',
    body: 'Poppins',
  },
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: true,
  },
})

export default theme
